<template lang="pug">
multiselect(
    track-by="id"
    label="name"
    :options="data"
    :internal-search="false"
    :value="value"
    @search-change="loadStocks"
    :loading="onLoading('fetch-stocks')"
    @select="onSelect"
    :placeholder="placeholder"
)
    template(slot="option", slot-scope="props")
        .clear
            span.clear {{ props.option.name }} {{ props.option.variant_name ? ' - ' + props.option.variant_name : null }}
            small.clear.text-muted {{ props.option.code }} {{ props.option.variant_code ? ' - ' + props.option.variant_code : null }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import inventoryStock from '@js/store/modules/inventory-stock';
import EventStock from '@js/franchise_component/franchise-inventory/stock/stock-event';

export default {
    props: {
        placeholder: {
            type: String,
            default: '',
        },

        excludeSupplierId: {
            type: Number,
            default: null,
        },

        supplierId: {
            type: Number,
            default: null,
        },

        value: {
            type: Object,
            default: () => null,
        },

        outletId: {
            type: Number,
            default: null,
        },

        products: {
            type: Array,
            default: () => null,
        },

        checkQty: {
            type: Boolean,
            default: false,
        },

        type: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            exclude_stock_ids: [],
            data: [],
        };
    },

    computed: {
        ...mapGetters('inventoryStock', ['stockList']),
    },

    watch: {
        stockList() {
            this.data = this.stockList.filter(
                stock => !this.exclude_stock_ids.includes(stock.id),
            );
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('inventoryStock')) {
            this.$store.registerModule('inventoryStock', inventoryStock);
        }
    },

    mounted() {
        this.loadStocks();

        this.$on('stock-list-reload', () => {
            this.loadStocks();
        });

        EventStock.$on('remove-stock-id', stock_id => {
            let stockId = stock_id;
            this.removeStockFromArray(stockId);
        });
    },

    methods: {
        ...mapActions('inventoryStock', ['getStockList', 'emptyStockList']),

        onSelect(stock) {
            this.$emit('select', stock);
            this.$emit('input', stock);
            this.exclude_stock_ids.push(stock.id);

            this.data = this.stockList.filter(
                stock => !this.exclude_stock_ids.includes(stock.id),
            );
        },

        loadStocks: _.debounce(function(query = '') {
            const params = {
                query,
                outlet_id: this.outletId,
                type: this.type,
            };

            this.getStockList(params);
        }, 500),

        removeStockFromArray(stockId) {
            var index = this.exclude_stock_ids.indexOf(stockId);

            if (index > -1) {
                this.exclude_stock_ids.splice(index, 1);
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/stock-selector.vue